import { Shield, Clock, PhoneCall, PiggyBank } from "lucide-react";
import { cn } from "@/lib/utils";
// framer-motion verwijderd — entree-animatie via `animate-fade-in` met inline delay.

const usps = [
  {
    icon: PiggyBank,
    title: "Vast laag maandbedrag",
    description: "Geen verrassingen op je factuur. Je weet precies wat je betaalt — elke maand.",
  },
  {
    icon: PhoneCall,
    title: "Direct een mens aan de lijn",
    description: "Geen tickets, geen wachtrijen. Je belt ons en een techneut helpt je meteen.",
  },
  {
    icon: Clock,
    title: "Maandelijks opzegbaar",
    description: "Wij geloven dat je bij ons blijft omdat je tevreden bent — niet omdat het moet.",
  },
  {
    icon: Shield,
    title: "Simpel & betrouwbaar",
    description: "Geen onnodige complexiteit. Wij kiezen bewust voor standaardoplossingen die gewoon werken.",
  },
];

const USPSection = () => {
  return (
    <section className="bg-muted/50 py-20 md:py-28">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold md:text-4xl">
            Waarom bedrijven kiezen voor{" "}
            <span className="text-gradient">Rinqel</span>
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Wij doen IT anders. Eerlijker, simpeler en met échte service.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {usps.map((usp, index) => {
            const Icon = usp.icon;
            return (
              <div
                key={usp.title}
                className="rounded-xl border border-border bg-card p-6 shadow-card animate-fade-in [animation-fill-mode:backwards]"
                style={{ animationDelay: `${index * 80}ms` }}
              >
                <div className={cn(
                  "mb-4 flex h-11 w-11 items-center justify-center rounded-xl",
                  index === 0 ? "bg-hero-gradient" : index === 1 ? "bg-rinqel-blue-gradient" : index === 2 ? "bg-rinqel-green-gradient" : "bg-hero-gradient"
                )}>
                  <Icon className="h-5 w-5 text-primary-foreground" />
                </div>
                <h3 className="text-lg font-semibold">{usp.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {usp.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default USPSection;
